export const FETCH_TESTS_COMPLETED = 'FETCH_TESTS_COMPLETED';
export const FETCH_TESTS_ERROR = 'FETCH_TESTS_ERROR';
export const FETCH_TESTS_STARTED = 'FETCH_TESTS_STARTED';

export const UPDATE_TESTS_CURRENT_PAGE = 'UPDATE_TESTS_CURRENT_PAGE';
export const UPDATE_TESTS_PAGE_SIZE = 'UPDATE_TESTS_PAGE_SIZE';

export const ADD_TEST_SEARCH = 'ADD_TEST_SEARCH';
export const CLEAR_TEST_SEARCH = 'CLEAR_TEST_SEARCH';

export const CLEAR_TEST_COLUMN_SORT = 'CLEAR_TEST_COLUMN_SORT';
export const UPDATE_TEST_COLUMN_SORT = 'UPDATE_TEST_COLUMN_SORT';
